import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SettingsPagesContainer from "../../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TournamentDetailsTemplateForm from "../../../../../components/tournamentDetailsTemplateForm/TournamentDetailsTemplateForm";
import { createTournamentDetailsTemplate } from "../../../../../features/tournamentDetailsTemplates/tournamentDetailsTemplatesSlice";
import styles from "./addTournamentDetailsTemplate.module.css";

const AddTournamentDetailsTemplate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Create directly (no confirmation modal — matches the Add Tournament flow),
  // then return to the list on success so the admin sees the new template.
  const handleCreate = (payload) => {
    dispatch(createTournamentDetailsTemplate(payload))
      .unwrap()
      .then(() => {
        navigate("/dashboard/tournaments/tournament-details-templates");
      })
      .catch(() => {});
  };

  return (
    <div className={styles.container}>
      <SettingsPagesContainer
        title="اضافة قالب تفاصيل بطولة"
        fullHeight
        displayContainerClassName={styles.displayContainer}
      >
        <TournamentDetailsTemplateForm
          submitLabel="تسجيل القالب الجديد"
          onSubmit={handleCreate}
        />
      </SettingsPagesContainer>
    </div>
  );
};

export default AddTournamentDetailsTemplate;
